import './messages.scss';

import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import gql from 'nanogql';
import Query from '../../query';
import Moment from 'moment';

export default class extends React.Component {

  state = {
    messages: [],
    hasMore: true
  };

  async loadMore() {
    this.loadMoreQueue = this.loadMoreQueue || Promise.resolve(null);
    return this.loadMoreQueue = this.loadMoreQueue
      .then(
        this.loadMoreQueued.bind(this)
      )
      .catch(console.warn);
  }

  async loadMoreQueued() {
    const limit = 15;

    const query = gql`
      query Query($input: ListSubmissionsInput, $identity: String) {
          listSubmissions(input: $input, identity: $identity) {
              name,
              email,
              phone,
              message,
              created_at,
              sequence
          }
      }
    `;

    const response = await Query(query, {
      input: {
        valid: true,
        skip: this.state.messages.length,
        limit
      }
    });

    const newMessages = response.listSubmissions;

    const messages = this.state.messages.concat(newMessages);

    await new Promise((resolve) => this.setState({
      messages,
      hasMore: newMessages.length === limit
    }, resolve));
  }

  render() {

    /*
     <div className="input-wrapper">
     <input type="text" placeholder="Search Feedback" />
     <label><i className="fa fa-search" /></label>
     </div>
     */
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.loadMore.bind(this)}
        hasMore={this.state.hasMore}
        loader={
          <div className="feedback-loader">
            Loading...
          </div>
        }
      >
        <div className="feedback">
          <div className="feedback-header">
            <h1><i className="fa fa-comments" />&nbsp;&nbsp;Feedback</h1>

          </div>
          {
            this.state.messages.map((message, index) => {
              return (
                <div className="feedback-row" key={index}>
                  <div className="feedback-row-details">
                    <p>
                      <label>Date</label>
                      {Moment(message.created_at).format('ddd, MMM Do YYYY, h:mm A')}
                    </p>
                    <p>
                      <label>Name</label>
                      {message.name}
                    </p>
                    <p>
                      <label>Email</label>
                      {message.email}
                    </p>
                    <p>
                      <label>Phone</label>
                      {message.phone}
                    </p>
                  </div>
                  <div className="feedback-row-message">
                    <p>
                      <label>Message</label>
                      <span>{message.message}</span>
                    </p>
                  </div>
                  <div className="feedback-row-sequence">
                    Feedback #{message.sequence}
                  </div>
                </div>
              )
            })
          }
        </div>
      </InfiniteScroll>
    )
  }

}


// WEBPACK FOOTER //
// ./src/pages/messages/index.js